(() => {
  if (window.innerStandardProductInit) { window.innerStandardProductInit(); return; }
  function init() {
    document.querySelectorAll('.is-pdp-start:not([data-is-ready])').forEach(marker => {
      marker.dataset.isReady = 'true';
      const root = marker.closest('[data-product-id][data-section-id]');
      if (!root) return;
      const help = marker.querySelector('.is-pdp-size-help');
      if (help) {
        const picker = root.querySelector('.variant-input-wrap');
        if (picker) picker.after(help);
        help.addEventListener('click', () => {
          const guide = root.querySelector('.is-pdp-size-guide');
          if (!guide) return;
          guide.open = true;
          guide.scrollIntoView({block:'center', behavior:'auto'});
          guide.querySelector('summary')?.focus({preventScroll:true});
        });
      }
      const position = Number(marker.dataset.isSizePosition);
      if (!position) return;
      const fieldset = root.querySelector('fieldset.variant-input-wrap[data-index="option' + position + '"]');
      if (!fieldset) return;
      const message = marker.querySelector('.is-pdp-size-message');
      if (!message) return;
      fieldset.after(message);
      let chosen = marker.dataset.isVariantSelected === 'true';
      if (!chosen) {
        fieldset.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = false; });
        message.hidden = false;
      }
      const accept = event => {
        let input = event.target.closest('input[type="radio"]');
        const label = event.target.closest('label');
        if (!input && label && label.htmlFor) input = document.getElementById(label.htmlFor);
        if (!input || !fieldset.contains(input)) return;
        chosen = !input.disabled && !input.classList.contains('disabled');
        message.hidden = chosen;
      };
      fieldset.addEventListener('click', accept, true);
      fieldset.addEventListener('change', accept, true);
      function requireSize(event) {
        const selected = fieldset.querySelector('input[type="radio"]:checked');
        if (chosen && selected && !selected.disabled && !selected.classList.contains('disabled')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        message.hidden = false;
        fieldset.scrollIntoView({block:'center', behavior:'auto'});
        const input = fieldset.querySelector('input:not(.disabled):not(:disabled)');
        if (input) input.focus({preventScroll:true});
      }
      root.addEventListener('click', event => {
        if (event.target.closest('button[name="add"], sticky-atc a.add-to-cart')) requireSize(event);
      }, true);
      root.addEventListener('submit', event => {
        if (event.target.matches('form[action*="/cart/add"]')) requireSize(event);
      }, true);
    });
  }
  window.innerStandardProductInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();